import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
// TODO:Agregar guards de rutas para evitar que entre en una ruta que no tenga permisos
import { __awaiter, __generator } from "tslib";
import AuthServices from '@/modules/auth/AuthServices';
import { loadLanguageAsync } from '@/setup/lang';
export function checkLogin(to, from, next) {
  return __awaiter(this, void 0, void 0, function () {
    var token;
    return __generator(this, function (_a) {
      token = localStorage.getItem('token');

      if (!token) {
        localStorage.removeItem('token');
        localStorage.removeItem('modules');
        return [2
        /*return*/
        , next({
          name: 'login'
        })];
      }

      return [2
      /*return*/
      ];
    });
  });
}
export function checkPermissions(to, from, next) {
  return __awaiter(this, void 0, void 0, function () {
    var modulePermissions, module, checkPerms, condition, permissions, e_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          modulePermissions = {};
          module = to.meta.modules;
          _a.label = 1;

        case 1:
          _a.trys.push([1, 3,, 4]);

          if (!localStorage.getItem('token')) {
            throw new Error('Neve Logged');
          }

          return [4
          /*yield*/
          , AuthServices.getPermissions({
            method: 'POST',
            query: {
              module: module
            }
          })];

        case 2:
          checkPerms = _a.sent();

          if (checkPerms.complete) {
            modulePermissions = checkPerms.data;

            if (!Object.keys(modulePermissions).length) {
              return [2
              /*return*/
              , next({
                name: 'not-bought'
              })];
            }

            condition = !Object.keys(modulePermissions).filter(function (module) {
              return 'view' in modulePermissions[module] && modulePermissions[module].view;
            }).length;

            if (condition) {
              return [2
              /*return*/
              , next({
                name: 'insufficient-permissions'
              })];
            }

            permissions = module.length === 1 ? modulePermissions[module[0]] : modulePermissions;
            localStorage.setItem('permissions', JSON.stringify(permissions)); // TODO: Cambiar de aqui

            return [2
            /*return*/
            , next()];
          }

          return [3
          /*break*/
          , 4];

        case 3:
          e_1 = _a.sent();
          next({
            name: 'login'
          });
          return [3
          /*break*/
          , 4];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
}
export function checkLang(to, from, next) {
  return __awaiter(this, void 0, void 0, function () {
    var lang;
    return __generator(this, function (_a) {
      lang = localStorage.getItem('lang') || navigator.language.split('-')[0];
      loadLanguageAsync(lang).then(function () {
        return next();
      }).catch(function () {
        next({
          name: 'LanguageNotSupported'
        });
      });
      return [2
      /*return*/
      ];
    });
  });
}